export default __webpack_public_path__ + "static/media/umy.639d0661.png";